import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent {
  constructor(private route: Router) {}

  ngOnInit(): void {
    localStorage.removeItem('token')
    localStorage.removeItem('userType')
    localStorage.removeItem('name')
    localStorage.removeItem('email')
    localStorage.removeItem('temppassword')

    localStorage.clear()
    
    this.route.navigate(['login'])
  }
}
